import React, { useState, useEffect, useRef } from "react";
import { useHistory, useLocation } from "react-router";
import { useOnOutsideClick } from "../../../hooks/useOutsideClick";
import {
  CardNumberElement,
  CardExpiryElement,
  CardCvcElement,
  useElements,
  useStripe,
  PaymentRequestButtonElement,
} from "@stripe/react-stripe-js";
import axios from "axios";
import {
  CardInputWrapper,
  PaymentBlock,
  PaymentFormBlock,
  SubscriptionBlock,
} from "../styled";
import {
  blackColor,
  blueDarkColor,
  darkColor,
  disabledColor,
  orangeColor, orangeColorSecond,
  whiteColor,
  lightThirdColor
} from "../../../constants/colors";
import { Heading, Text } from "../../../styled";
import secureIcon from "../../../resources/images/paymentForm/secure_icon.png";
import stripeIcon from "../../../resources/images/paymentForm/stripe_icon.png";
import questionIcon from "./../../../resources/images/paymentForm/question.svg";
import unionWhite from "./../../../resources/images/subscription/union_white.svg";
import cvv from "./../../../resources/images/paymentForm/cvv.svg";
import pmCard from "./../../../resources/images/paymentForm/pm_card.png";
import pmCardDisabled from "../../../resources/images/paymentForm/pm_card_disabled.png"
import pmPaypal from "./../../../resources/images/paymentForm/pm_paypal.png";
import pmPaypalDisabled from "./../../../resources/images/paymentForm/pm_paypal_disabled.png";
import warningIcon from "./../../../resources/images/paymentForm/warning.svg";
import cardIcon from "./../../../resources/images/paymentForm/card_icon.svg";
import paypallIcon from "./../../../resources/images/paymentForm/paypall.png";
import Button from "../../design_components/Button/Button";
import {
  checkValueToType,
  checkValueToLength,
} from "../../../utils/validators";
import {
  createEventObjectFunction,
  setProductSum,
  setTimeFunction,
} from "../../../utils/helper";
import {
  paymentInfoAddEventAmplitude,
  checkoutInitiateEventAmplitude,
  trialStartEventAmplitude,
  revenueAmplitude,
  paymentTypeEventAmplitude,
} from "../../../amplitude/events";
import {
  checkoutInitiateEvent,
  paymentInfoAddEvent,
  paymentTypeEvent,
  revenueFirebase,
} from "../../../firebaseAnalytics/events";
import { analytics } from "../../../firebaseAnalytics";
import ReactPixel from "react-facebook-pixel";
import {
  PAYWALL_FIRST,
  PAYWALL_FOURTH,
  paywall_fourth_info_block_bottom,
  paywall_fourth_info_block_top,
} from "../../../constants/data";
import { useSelector } from "react-redux";
import okIcon from "../../../resources/images/subscription/ok_orange_icon.svg";
import {
  FINISH_EMAIL_ROUTE,
  OFFER_30_ROUTE,
  OFFER_50_ROUTE,
} from "../../../constants/routes";

const PaymentForm = ({
  userEmail,
  userSum,
  pixelObject,
  paypalActions,
  isPaypalMethod,
  setPaypalMethod,
  isPaypalAvailable,
  setWhyPopupVisible,
  currentProduct,
  withoutTrial,
  isEmailPaywall,
  sumObj,
  contentRenderFunction,
  isNewEmailPaywall
}) => {
  const [success, setSuccess] = useState(false);
  const [isAllFieldsComplete, setAllFieldsComplete] = useState(false);

  // first name validation
  const [name, setName] = useState("");
  const [isNameCorrect, setNameCorrect] = useState(true);
  const [isNameComplete, setNameComplete] = useState(false);
  const [nameErrorMessage, setNameErrorMessage] = useState("");

  // card number validation
  const [isCardNumberCorrect, setCardNumberCorrect] = useState(true);
  const [isCardNumberComplete, setCardNumberComplete] = useState(false);
  const [cardNumberErrorMessage, setCardNumberErrorMessage] = useState("");

  // date validation
  const [isDateCorrect, setDateCorrect] = useState(true);
  const [isDateComplete, setDateComplete] = useState(false);
  const [dateErrorMessage, setDateErrorMessage] = useState("");

  // cvv validation
  const [isCvvCorrect, setCvvCorrect] = useState(true);
  const [isCvvComplete, setCvvComplete] = useState(false);
  const [cvvErrorMessage, setCvvErrorMessage] = useState("");

  // postCode validation
  const [postCode, setPostCode] = useState("");
  const [isPostCorrect, setPostCorrect] = useState(true);
  const [isPostComplete, setPostComplete] = useState(false);
  const [postErrorMessage, setPostErrorMessage] = useState("");

  const [isCvvPopupOpen, setCvvPopupOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [finishTime, setFinishTime] = useState(null);
  const [millisecondsFinishTime, setMillisecondsFinishTime] = useState(null);

  // geo state
  const [currentCountry, setCurrentCountry] = useState("United States");
  const [isInputOnFocus, setInputOnFocus] = useState(false);
  const [isInputFocusFirst, setInputFocusFirst] = useState(true);

  // common validation error
  const [commonErrorMessage, setCommonErrorMessage] = useState("");

  // applePay
  const [messages, addMessages] = useState("");
  const [paymentRequest, setPaymentRequest] = useState(null);

  const remoteConfig = useSelector((state) => state.questions.remoteConfig);
  const landingId = useSelector((state) => state.questions.landingId);

  const inputStyle = {
    color: darkColor,
    fontWeight: "700",
    fontFamily: "SF, sans-serif",
    fontSize: "16px",
    background: whiteColor,
    borderRadius: 12,
    fontSmoothing: "antialiased",
    ":-webkit-autofill": {
      color: darkColor,
      backgroundColor: "transparent",
    },
    "::placeholder": {
      color: "#6C6C6C",
      fontFamily: "SF, sans-serif",
      fontWeight: 500,
      fontSize: 18,
    },
  };

  const stripe = useStripe();
  const elements = useElements();
  const history = useHistory();
  const location = useLocation();

  useEffect(() => {
    if (!stripe || !elements) {
      return;
    }
    setTimeout(() => applePaySubscription(), 1500);
  }, [stripe, elements, addMessages]);

  const applePaySubscription = () => {
    const pr = stripe.paymentRequest({
      currency: "usd",
      country: "US",
      requestPayerEmail: true,
      requestPayerName: true,
      total: {
        label: setProductSum(currentProduct || process.env.REACT_APP_PRODUCT)
          .name,
        amount:
          withoutTrial === true
            ? Math.round(Number(setProductSum(currentProduct).sum) * 100)
            : 0,
      },
    });

    pr.canMakePayment().then((res) => {
      // Объект с полями applePay и googlePay
      // оставляем пока только applePay
      if (res) {
        setPaymentRequest(pr);
      }
    });

    pr.on("paymentmethod", async (e) => {
      // create a payment intent on the server
      let bodyObj = {
        paymentMethodType: e.paymentMethod.id,
        currency: "usd",
        amount: 100,
        product: currentProduct || process.env.REACT_APP_PRODUCT,
        email: userEmail,
      };
      if (!withoutTrial) {
        bodyObj.trial_end = millisecondsFinishTime;
      }
      const res = await fetch(
        `${process.env.REACT_APP_API_URL}/create-payment-intent`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(bodyObj),
        }
      );

      let paymentID = res.id;
      const eventOb = createEventObjectFunction(null, null, landingId);

      // Событие №11 trial_start
      revenueFirebase("trial", paymentID, Number(userSum), analytics, eventOb);
      ReactPixel.trackCustom("Purchase", {
        value: `${userSum}`,
        currency: "USD",
      });
      const eventObj = createEventObjectFunction(null, null, landingId);
      let dataObj = {
        payment_method: e.paymentMethod.id,
        email: userEmail,
        product: process.env.REACT_APP_PRODUCT,
        data: {
          currentCountry: "US",
          name,
          postCode,
        },
      };
      dataObj.product = currentProduct
        ? currentProduct
        : process.env.REACT_APP_PRODUCT;

      // Событие №10 checkout_initiate
      checkoutInitiateEvent(analytics, eventObj);
      checkoutInitiateEventAmplitude(eventObj);

      // trial start событие
      trialStartEventAmplitude(eventOb);

      // передать сумму последующего платежа
      revenueAmplitude(dataObj, 1, Number(setProductSum(dataObj.product).sum));
      ReactPixel.trackCustom("Initiate checkout", pixelObject);
      setLoading(false);

      e.complete("success");
      setTimeout(() => redirectToFinalScreen(), 500);
    });
  };

  const paymentMethodChange = (method) => {
    const paymentTypeObject = {
      type: method,
    };
    paymentTypeEvent(analytics, paymentTypeObject);
    paymentTypeEventAmplitude(paymentTypeObject);
  };

  const redirectToFinalScreen = () => {
    if (
      location.pathname === OFFER_50_ROUTE ||
      location.pathname === OFFER_30_ROUTE
    ) {
      history.push(FINISH_EMAIL_ROUTE);
    } else {
      history.push("/finish");
    }
  };

  const handleSubmit = async (e, sum) => {
    setLoading(true);
    const { error, paymentMethod } = await stripe.createPaymentMethod({
      type: "card",
      card: elements.getElement(CardNumberElement),
    });
    if (!error) {
      try {
        const { id } = paymentMethod;
        let dataObj = {
          amount: userSum * 100,
          id,
          email: userEmail,
          data: {
            currentCountry,
            name,
            lastName,
            postCode,
          },
        };
        const response = await axios.post(
          `${process.env.REACT_APP_API_URL}/payment`,
          dataObj
        );
        if (response.data.success) {
          setCommonErrorMessage("");
          setSuccess(false);
        } else {
          setCommonErrorMessage(response.data.message);
          setLoading(false);
        }
      } catch (e) {
        setCommonErrorMessage(e.message);
        setLoading(false);
      }
    } else {
      setCommonErrorMessage(error.message);
      setLoading(false);
    }
  };

  const handleSubmitSubscription = async (e) => {
    setLoading(true);
    let paymentID;
    if (!stripe || !elements) {
      return;
    }

    const result = await stripe.createPaymentMethod({
      type: "card",
      card: elements.getElement(CardNumberElement),
    });
    if (result.error) {
      setCommonErrorMessage(result.error.message);
      setLoading(false);
    } else {
      try {
        let dataObj = {
          payment_method: result.paymentMethod.id,
          email: userEmail,
          product: process.env.REACT_APP_PRODUCT,
          data: {
            currentCountry: "US",
            name,
            // lastName,
            postCode,
          },
        };
        if (!withoutTrial) {
          dataObj.billing_cycle_anchor = millisecondsFinishTime;
          dataObj.trial_end = millisecondsFinishTime;
        }
        dataObj.product = currentProduct
          ? currentProduct
          : process.env.REACT_APP_PRODUCT;

        const res = await axios.post(
          `${process.env.REACT_APP_API_URL}/sub`,
          dataObj
        );
        const { client_secret, status } = res.data;
        paymentID = res.data.id;
        if (status === "required_action") {
          stripe.confirmCardPayment(client_secret).then(function (result) {
            if (result.error) {
              setCommonErrorMessage(e.message);
              setLoading(false);
            } else {
              ReactPixel.trackCustom("Initiate checkout", pixelObject);
              const eventObj = createEventObjectFunction(null, null, landingId);
              // Событие №10 checkout_initiate
              checkoutInitiateEvent(analytics, eventObj);
              checkoutInitiateEventAmplitude(eventObj);
              redirectToFinalScreen();
              setCommonErrorMessage("");
              setLoading(false);
            }
          });
        } else {
          const eventOb = createEventObjectFunction(null, null, landingId);
          // Событие №11 trial_start
          revenueFirebase(
            "trial",
            paymentID,
            Number(userSum),
            analytics,
            eventOb
          );
          ReactPixel.trackCustom("Purchase", {
            value: `${userSum}`,
            currency: "USD",
          });
          const eventObj = createEventObjectFunction(null, null, landingId);
          // Событие №10 checkout_initiate
          checkoutInitiateEvent(analytics, eventObj);
          checkoutInitiateEventAmplitude(eventObj);
          // trial start событие
          trialStartEventAmplitude(eventOb);
          // передать сумму последующего платежа

          revenueAmplitude(
            dataObj.product,
            1,
            Number(setProductSum(dataObj.product).sum)
          );
          ReactPixel.trackCustom("Initiate checkout", pixelObject);
          redirectToFinalScreen();
          setLoading(false);
        }
      } catch (e) {
        console.log(e);
        setCommonErrorMessage("Something went wrong");
        setLoading(false);
      }
    }
  };

  const handleSubmitPayAndSubscriptionClick = async () => {
    if (remoteConfig.paidTrialEnabled && userSum > 0) {
      await handleSubmit();
      await handleSubmitSubscription();
    } else {
      await handleSubmitSubscription();
    }
  };

  const handleCustomInputChange = (
    length,
    e,
    setCorrectFunction,
    setCompleteFunction,
    setErrorMessageFunction,
    setDataFunction,
    type
  ) => {
    if (setDataFunction) {
      setDataFunction(e.target.value);
    }
    checkValueToLength(
      length,
      e.target.value,
      setCorrectFunction,
      setCompleteFunction,
      setErrorMessageFunction
    );
    if (e.target.value.length) {
      checkValueToType(
        type,
        e.target.value,
        setCorrectFunction,
        setCompleteFunction,
        setErrorMessageFunction
      );
    }
  };

  const handleInputChange = (
    e,
    setCorrectFunction,
    setCompleteFunction,
    setErrorMessageFunction
  ) => {
    setCorrectFunction(!e.error);
    if (e.error && e.error.message) {
      setErrorMessageFunction(e.error.message);
    } else {
      setErrorMessageFunction("");
    }
    setCompleteFunction(e.complete);
  };

  useEffect(() => {
    setTimeFunction(setFinishTime, setMillisecondsFinishTime);
  }, []);

  useEffect(() => {
    setAllFieldsComplete(
      isDateComplete &&
        isCvvComplete &&
        isCardNumberComplete &&
        isNameComplete &&
        isPostComplete
    );
  }, [
    isDateComplete,
    isCvvComplete,
    isCardNumberComplete,
    isNameComplete,
    isPostComplete,
  ]);

  useEffect(() => {
    if (setInputFocusFirst && isInputOnFocus === true) {
      ReactPixel.trackCustom("Add payment info", pixelObject);
      const eventObj = createEventObjectFunction(null, null, landingId);
      // Событие №9 paymentinfo_add
      paymentInfoAddEvent(analytics, eventObj);
      paymentInfoAddEventAmplitude(eventObj);
    }
  }, [isInputOnFocus]);

  useEffect(() => {
    if (isPaypalMethod === true) {
      const paymentTypeObject = {
        type: isPaypalMethod ? "paypal" : "card",
      };
      paymentTypeEvent(analytics, paymentTypeObject);
      paymentTypeEventAmplitude(paymentTypeObject);
    }
  }, [isPaypalMethod]);

  const handleQuestionClick = () => {
    if (isCvvComplete === true) {
      return false;
    }
    const cvvPopupOpen = isCvvPopupOpen;
    setCvvPopupOpen(!cvvPopupOpen);
  };

  const handleInputFocus = () => {
    setInputOnFocus(true);
    setInputFocusFirst(false);
  };

  const { innerBorderRef } = useOnOutsideClick(() => setCvvPopupOpen(false));

  const paymentTypeRender = () => {
    return (
      <>
        {isEmailPaywall && !remoteConfig.paypalEnabled ? (
          <div className="payment-block-cards">
            <img src={pmCard} alt="pm" />
          </div>
        ) : (
          <div className="payment-block-chose">
            <div
              className={`payment-block-chose-item ${
                !isPaypalMethod ? null : "active"
              }`}
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                height: isNewEmailPaywall ? 54 : null,
                backgroundColor: isNewEmailPaywall && !isPaypalMethod ? lightThirdColor : null
              }}
              onClick={isPaypalAvailable ? () => setPaypalMethod(true) : false}
            >
              <div className="payment-block-chose-item-warning">
                {isPaypalAvailable ? null : (
                  <img src={warningIcon} alt="warning" />
                )}
              </div>
              <div className="payment-block-chose-item-paypal">
                <img src={!isPaypalMethod && isNewEmailPaywall ? pmPaypalDisabled : pmPaypal} alt="paypal" />
              </div>
            </div>
            <div
              style={{height: isNewEmailPaywall ? 54 : null, backgroundColor: isNewEmailPaywall && isPaypalMethod ? lightThirdColor : null}}
              className={`payment-block-chose-item ${
                isPaypalMethod ? null : "active"
              }`}
              onClick={() => setPaypalMethod(false)}
            >
              <div className="payment-block-chose-item-top" style={{marginBottom: isNewEmailPaywall ? 0 : null}}>
                <Text.Eight
                  style={{
                    color: blackColor,
                    opacity: 0.5,
                    textTransform: "none",
                    letterSpacing: 0,
                    fontWeight: 700,
                  }}
                >
                  Credit Card
                </Text.Eight>
              </div>
              <div className="payment-block-chose-item-bottom">
                <img src={isPaypalMethod && isNewEmailPaywall ? pmCardDisabled : pmCard} style={{width: isNewEmailPaywall ? 110 : null}} alt="pmCard" />
              </div>
            </div>
          </div>
        )}
      </>
    );
  };

  const totalRender = () => {
    return (
      <div
        className="paywall-first-center"
        style={{ border: remoteConfig.paywallId === PAYWALL_FOURTH && "none" }}
      >
        <div className="paywall-first-total">
          <Text.Third
            style={{
              color: blackColor,
              fontWeight: 600,
            }}
          >
            Total today
          </Text.Third>
          {!remoteConfig.paidTrialEnabled ? (
            <Text.Third
              style={{
                color:
                  remoteConfig.paywallId === PAYWALL_FOURTH
                    ? "#EB6B24"
                    : orangeColor,
                fontWeight: 600,
              }}
            >
              0$
            </Text.Third>
          ) : null}
        </div>
        {remoteConfig.paywallId !== PAYWALL_FOURTH ? (
          <>
            <div
              className="paywall-first-between"
              style={{ marginTop: 18, marginBottom: 18 }}
            >
              <Text.Third
                style={{
                  color: blackColor,
                  fontWeight: 400,
                }}
              >
                {!remoteConfig.paidTrialEnabled
                  ? "Price after 7-day free trial"
                  : `7-day trial`}
              </Text.Third>
              <Text.Third
                style={{
                  color: blackColor,
                  fontWeight: 700,
                }}
              >
                {!remoteConfig.paidTrialEnabled ? "$1.35/week" : `$${userSum}`}
              </Text.Third>
            </div>
            {!remoteConfig.paidTrialEnabled ? (
              <div
                className="paywall-first-between"
                style={{ marginBottom: 6 }}
              >
                <Text.Third
                  style={{
                    color: blackColor,
                    fontWeight: 400,
                  }}
                >
                  Billed annually at
                </Text.Third>
                <div className="paywall-first-between-text">
                  <Text
                    className="decor"
                    style={{
                      color: blueDarkColor,
                      textAlign: "left",
                      fontWeight: 600,
                      fontSize: 18,
                      opacity: 0.7,
                    }}
                  >
                    $99.99
                  </Text>
                  <Text
                    style={{
                      color: blackColor,
                      fontWeight: 600,
                      fontSize: 18,
                    }}
                  >
                    $69.99
                  </Text>
                </div>
              </div>
            ) : (
              <>
                <div
                  className="paywall-first-between-paid"
                  style={{ marginBottom: 19 }}
                >
                  <Heading.Fifth
                    style={{
                      color: blackColor,
                      fontWeight: 600,
                    }}
                  >
                    Price after trial:
                  </Heading.Fifth>
                </div>
                <div
                  className="paywall-first-between-banner"
                  style={{ marginBottom: 5 }}
                >
                  <Text.Fifth style={{ color: whiteColor }}>30% OFF</Text.Fifth>
                </div>
                <div
                  className="paywall-first-between"
                  style={{ marginBottom: 6 }}
                >
                  <Text.Third
                    style={{
                      color: blackColor,
                      fontWeight: 400,
                    }}
                  >
                    Annual plan
                  </Text.Third>
                  <div className="paywall-first-between-text">
                    <Text
                      className="decor"
                      style={{
                        color: blueDarkColor,
                        textAlign: "left",
                        fontWeight: 600,
                        fontSize: 18,
                        opacity: 0.7,
                      }}
                    >
                      $99.99
                    </Text>
                    <Text
                      style={{
                        color: blackColor,
                        fontWeight: 600,
                        fontSize: 18,
                      }}
                    >
                      $69.99
                    </Text>
                  </div>
                </div>
              </>
            )}
          </>
        ) : (
          contentRenderFunction && contentRenderFunction(27, null, "#F3F2FF")
        )}
      </div>
    );
  };

  const totalEmailRender = () => {
    return (
      <>
        <div
          className="paywall-first-center"
          style={{
            border: "none",
            paddingBottom: 8,
            marginBottom: 15,
            borderBottom: "1px solid #CAC5C2",
          }}
        >
          <div
            className="paywall-first-total"
            style={{
              marginBottom: 7,
              padding: 0,
              border: "none",
            }}
          >
            <Text.Fifth
              style={{
                color: "#6C6C6C",
                fontWeight: 500,
                fontSize: isNewEmailPaywall ? 16 : null,
                lineHeight: isNewEmailPaywall ? '20.8px' : null
              }}
            >
              {isNewEmailPaywall ? 'Journey Sleep Music ' : 'Personalized Sleepscape Plan'}
            </Text.Fifth>

            <Text.Fifth
              style={{
                color: "#6C6C6C",
                fontWeight: 500,
                fontSize: isNewEmailPaywall ? 16 : null,
                lineHeight: isNewEmailPaywall ? '20.8px' : null
              }}
            >
              {isNewEmailPaywall ? `$${sumObj.discountSum}` : `$${sumObj.startSum}`}
            </Text.Fifth>
          </div>
          <div
            className="paywall-first-total"
            style={{ marginBottom: 7, padding: 0, border: "none", display: isNewEmailPaywall ? 'none' : null }}
          >
            <Text.Fifth
              style={{
                color: "#6C6C6C",
                fontWeight: 500,
              }}
            >
              {`${sumObj.discountText}`}
            </Text.Fifth>
            <Text.Fifth
              style={{
                color: "#E24B4B",
                fontWeight: 500,
              }}
            >
              {`-$${sumObj.discountSum}`}
            </Text.Fifth>
          </div>
        </div>
        <div
          className="paywall-first-total"
          style={{ marginBottom: isNewEmailPaywall ? 59 : 1, padding: 0, border: "none" }}
        >
          <Text.Fourth
            style={{
              color: blackColor,
              fontWeight: 700,
            }}
          >
            Total
          </Text.Fourth>
          <Text.Fourth
            style={{
              color: blackColor,
              fontWeight: 700,
            }}
          >
            {`$${sumObj.finalSum}`}
          </Text.Fourth>
        </div>
        <div
          className="paywall-first-total"
          style={{
            marginBottom: 59,
            padding: 0,
            border: "none",
            display: isNewEmailPaywall ? 'none' : null
          }}
        >
          <Text.Fifth />
          <Text.Fifth
            style={{
              color: "#E24B4B",
              fontWeight: 500,
            }}
          >
            {`${sumObj.bottomText}`}
          </Text.Fifth>
        </div>
      </>
    );
  };

  const formRender = () => {
    return (
      <form id="card-form">
        <CardInputWrapper.Horizontal style={{ marginBottom: 16 }}>
          <CardInputWrapper isValid={isNameCorrect} isComplete={isNameComplete}>
            <input
              type="text"
              placeholder={"Name on card"}
              onFocus={handleInputFocus}
              onChange={(e) =>
                handleCustomInputChange(
                  2,
                  e,
                  setNameCorrect,
                  setNameComplete,
                  setNameErrorMessage,
                  setName,
                  "name"
                )
              }
            />
            {nameErrorMessage ? (
              <CardInputWrapper.Message>
                {nameErrorMessage}
              </CardInputWrapper.Message>
            ) : null}
          </CardInputWrapper>
        </CardInputWrapper.Horizontal>
        <CardInputWrapper
          className={"cardnumber"}
          isValid={isCardNumberCorrect}
          isComplete={isCardNumberComplete}
        >
          <CardNumberElement
            onFocus={handleInputFocus}
            onChange={(e) =>
              handleInputChange(
                e,
                setCardNumberCorrect,
                setCardNumberComplete,
                setCardNumberErrorMessage
              )
            }
            options={{
              style: {
                base: inputStyle,
                paddingLeft: 40,
              },
            }}
          />
          {cardNumberErrorMessage ? (
            <CardInputWrapper.Message>
              {cardNumberErrorMessage}
            </CardInputWrapper.Message>
          ) : null}
          <CardInputWrapper.Icon>
            <img src={cardIcon} alt="" />
          </CardInputWrapper.Icon>
        </CardInputWrapper>
        <CardInputWrapper.Horizontal style={{ marginBottom: 16 }}>
          <CardInputWrapper.Half
            isValid={isDateCorrect}
            isComplete={isDateComplete}
          >
            <CardExpiryElement
              onFocus={handleInputFocus}
              onChange={(e) =>
                handleInputChange(
                  e,
                  setDateCorrect,
                  setDateComplete,
                  setDateErrorMessage
                )
              }
              options={{
                style: {
                  base: inputStyle,
                },
              }}
            />
            {dateErrorMessage ? (
              <CardInputWrapper.Message>
                {dateErrorMessage}
              </CardInputWrapper.Message>
            ) : null}
            {/*{isDateComplete ? (*/}
            {/*  <CardInputWrapper.Icon>*/}
            {/*    <img src={okIcon} alt="" />*/}
            {/*  </CardInputWrapper.Icon>*/}
            {/*) : null}*/}
          </CardInputWrapper.Half>
          <CardInputWrapper.Half
            isValid={isCvvCorrect}
            isComplete={isCvvComplete}
          >
            <CardCvcElement
              onFocus={handleInputFocus}
              onChange={(e) =>
                handleInputChange(
                  e,
                  setCvvCorrect,
                  setCvvComplete,
                  setCvvErrorMessage
                )
              }
              options={{
                style: {
                  base: inputStyle,
                },
              }}
            />
            {cvvErrorMessage ? (
              <CardInputWrapper.Message>
                {cvvErrorMessage}
              </CardInputWrapper.Message>
            ) : null}
            <CardInputWrapper.Icon
              className={"cvv"}
              onClick={handleQuestionClick}
            >
              <img src={questionIcon} alt="" />
            </CardInputWrapper.Icon>
            {isCvvPopupOpen ? (
              <CardInputWrapper.Tooltip ref={innerBorderRef}>
                <img src={cvv} alt="" style={{ marginBottom: 9 }} />
                <Text.Fifth style={{ color: "#000000" }}>
                  Your card’s security code (CVV) is the 3 or 4 digit number
                  located on the back of most cards.
                </Text.Fifth>
                <CardInputWrapper.Tooltip.Arrow />
              </CardInputWrapper.Tooltip>
            ) : null}
          </CardInputWrapper.Half>
        </CardInputWrapper.Horizontal>
        <CardInputWrapper
          isValid={isPostCorrect}
          isComplete={isNameComplete}
          style={{ marginBottom: 16 }}
        >
          <input
            type="text"
            placeholder={"Zip/Postal Code"}
            onFocus={handleInputFocus}
            onChange={(e) =>
              handleCustomInputChange(
                4,
                e,
                setPostCorrect,
                setPostComplete,
                setPostErrorMessage,
                setPostCode,
                "number"
              )
            }
          />
          {postErrorMessage ? (
            <CardInputWrapper.Message>
              {postErrorMessage}
            </CardInputWrapper.Message>
          ) : null}
          {/*{isPostComplete ? (*/}
          {/*  <CardInputWrapper.Icon>*/}
          {/*    <img src={okIcon} alt="" />*/}
          {/*  </CardInputWrapper.Icon>*/}
          {/*) : null}*/}
        </CardInputWrapper>
        {/*<PaymentBlock.Select style={{ marginBottom: 32 }}>*/}
        {/*  <select*/}
        {/*    value={currentCountry}*/}
        {/*    onChange={(e) => setCurrentCountry(e.target.value)}*/}
        {/*    onFocus={handleInputFocus}*/}
        {/*  >*/}
        {/*    {countryList.map((country) => {*/}
        {/*      return (*/}
        {/*        <option value={country} key={country}>*/}
        {/*          {country}*/}
        {/*        </option>*/}
        {/*      );*/}
        {/*    })}*/}
        {/*  </select>*/}
        {/*</PaymentBlock.Select>*/}
        {commonErrorMessage ? (
          <CardInputWrapper.Message.Common>
            {commonErrorMessage}
          </CardInputWrapper.Message.Common>
        ) : null}
        <PaymentBlock.Form.Info.Button>
          <Button
            text={
              !isEmailPaywall
                ? remoteConfig.paidTrialEnabled
                  ? "Start Your 7-Day Trial"
                  : "Start 7-Day Free Trial"
                : "Continue"
            }
            type={"default"}
            isGradient={true}
            disabled={!isAllFieldsComplete}
            action={(e) => handleSubmitPayAndSubscriptionClick(e)}
            isLoading={loading}
            style={{
              pointerEvents: loading || !isAllFieldsComplete ? "none" : "auto",
            }}
            icon={isAllFieldsComplete ? null : unionWhite}
          />
        </PaymentBlock.Form.Info.Button>
        {isEmailPaywall || remoteConfig.paywallId === PAYWALL_FOURTH ? null : (
          <PaymentBlock.Form.Info.Text>
            <Text.Fourth
              style={{ color: blackColor, opacity: 0.7, fontWeight: 400 }}
            >
              {` ${
                remoteConfig.paidTrialEnabled
                  ? ""
                  : "You won't be charged until after your free trial."
              } Cancel anytime. 30 days money-back guarantee`}
            </Text.Fourth>
          </PaymentBlock.Form.Info.Text>
        )}
      </form>
    );
  };

  const paypalFormRender = () => {
    return (
      <div>
        <Button
          text={"Buy now"}
          type={"default"}
          isGradient={true}
          action={() => handlePaypalClick()}
          icon={paypallIcon}
          fontSize={20}
          fontWeight={600}
          style={{ background: "#F5C456" }}
          color={blackColor}
        />
        {isNewEmailPaywall ? (<Text.Fifth
          style={{
            color: blueDarkColor,
            opacity: 0.7,
            marginTop: 20
          }}
        >
            The safer, easier way to pay
        </Text.Fifth>) :
          (<Text.Fourth
          style={{
            color: blueDarkColor,
            opacity: 0.7,
            marginTop: 12,
            marginBottom: 25,
          }}
        >
          You won't be charged until your trial is over.
        </Text.Fourth>)}
      </div>
    );
  };

  const handlePaypalClick = () => {
    paypalActions[remoteConfig.paywallId](true);
  };

  const firstPaywallFormRender = () => {
    return !isPaypalMethod ? formRender() : paypalFormRender();
  };

  const renderBottomTextBlock = () => {
    return !isEmailPaywall ? (
      <PaymentBlock.Form.Info.Time>
        <span className={"bold"}>
          {`Your 7-day trial last until ${finishTime}.`}
        </span>{" "}
        <span>
          {`You may cancel at any time before ${finishTime}, and you will not be charged ${
            remoteConfig.paidTrialEnabled ? "the annual membership fee" : ""
          }. If you don’t cancel,`}
        </span>{" "}
        <span className={"bold"}>
          Journey will automatically continue your membership at the end of your
          7-day trial and charge the membership fee (currently $69.99)
        </span>{" "}
        <span>
          on a yearly basis until your cancel. No refunds or credits for partial
          years. You can cancel your subscriptions anytime on your Subscription
          Management page.
        </span>
      </PaymentBlock.Form.Info.Time>
    ) : (
      <PaymentBlock.Form.Info.Time>
        <span>
          {`Your subscription last until ${sumObj.finishTime}. If you don’t cancel, Journey will automatically continue your membership (currently $${sumObj.finalSum}) on a ${sumObj.period} basis until your cancel. No refunds or credits for partial ${sumObj.periodText}. You can cancel your subscriptions anytime on your Subscription Management page.`}
        </span>
      </PaymentBlock.Form.Info.Time>
    );
  };

  const infoWithTitleBlockRender = (dataObj) => {
    return (
      <div className="paywall-underlined">
        <div className="paywall-underlined-title">
          <Text.Second style={{ textAlign: "left", fontWeight: 800 }}>
            {dataObj.title}
          </Text.Second>
        </div>
        <div className="paywall-underlined-text">
          <Text.Fourth
            style={{ textAlign: "left", color: disabledColor }}
            dangerouslySetInnerHTML={dataObj.text}
          />
        </div>
      </div>
    );
  };

  return (
    <PaymentFormBlock>
      <div className="payment-block-title">
        <Heading.Fifth style={{ color: blackColor }}>
          {isEmailPaywall && remoteConfig.paypalEnabled
            ? "Select payment method"
            : "Payment method"}
        </Heading.Fifth>
        {!isNewEmailPaywall && <Text.Fourth
          style={{ color: "#5DB574", fontWeight: 600 }}
          onClick={() => setWhyPopupVisible(true)}
          >
          Risk free
          </Text.Fourth>
        }
      </div>
      {paymentRequest && (
        <div style={{ marginBottom: 15, overflow: "hidden", borderRadius: 8 }}>
          <PaymentRequestButtonElement
            onClick={() => paymentMethodChange("applepay")}
            options={{ paymentRequest }}
          />
        </div>
      )}
      {paymentTypeRender()}
      {isEmailPaywall ? totalEmailRender() : totalRender()}
      {remoteConfig.paywallId !== PAYWALL_FIRST &&
      remoteConfig.paywallId !== PAYWALL_FOURTH
        ? formRender()
        : firstPaywallFormRender()}
      <PaymentBlock.Form.Info.Img
        style={{
          flexDirection:
            remoteConfig.paywallId === PAYWALL_FOURTH ? "row-reverse" : "row",
          display: isNewEmailPaywall && isPaypalMethod ? 'none' : null
        }}
      >
        <img style={{ width: 100, order: isNewEmailPaywall ? 2 : null }} src={secureIcon} alt="" />
        {!isPaypalMethod ? (
          <img style={{ width: 142,  order: isNewEmailPaywall ? 1 : null  }} src={stripeIcon} alt="" />
        ) : null}
      </PaymentBlock.Form.Info.Img>
      {remoteConfig.paywallId === PAYWALL_FOURTH && !isNewEmailPaywall ? (
        <>
          <Text.Third
            style={{ fontSize: 14, lineHeight: "18px", marginBottom: 48 }}
          >
            You won't be charged until after your free trial. Cancel anytime. 30
            days money-back guarantee.
          </Text.Third>
          <div style={{ marginBottom: 10 }}>
            {infoWithTitleBlockRender(paywall_fourth_info_block_top)}
          </div>
          <div>
            {infoWithTitleBlockRender(paywall_fourth_info_block_bottom)}
          </div>
        </>
      ) : (
        <SubscriptionBlock.List.Items style={{display: isNewEmailPaywall && isPaypalMethod ? 'none' : null}}>
          <SubscriptionBlock.List.Item
            style={{ alignItems: "flex-start", marginBottom: 0 }}
          >
            <SubscriptionBlock.List.Item.Img
              style={{ paddingTop: 5, minWidth: 32 }}
            >
              <img src={okIcon} alt="ok" />
            </SubscriptionBlock.List.Item.Img>
            <SubscriptionBlock.List.Item.Text>
              <Text.Third>
                You will be sent an email receipt each time your subscription
                renews
              </Text.Third>
            </SubscriptionBlock.List.Item.Text>
          </SubscriptionBlock.List.Item>
        </SubscriptionBlock.List.Items>
      )}
      {remoteConfig.paywallId !== PAYWALL_FOURTH && !isNewEmailPaywall
        ? renderBottomTextBlock()
        : null}
    </PaymentFormBlock>
  );
};

export default PaymentForm;
